import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ShiftSmartScoreName } from '@wilson/interfaces';
import { SmartScoreMap } from '@wilson/shift/core';
import { ScoreDisplayComponent } from '../score-display/score-display.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'wilson-tooltip-smart-score-breakdown',
  templateUrl: './tooltip-smart-score-breakdown.component.html',
  styleUrls: ['./tooltip-smart-score-breakdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ScoreDisplayComponent, TranslatePipe],
})
export class TooltipSmartScoreBreakdownComponent {
  @Input() smartScores!: SmartScoreMap;
  ShiftSmartScoreName = ShiftSmartScoreName;
}
